
export function buildCdnUrl(url: string, cdnBaseUrl: string): string {
  if (!url) {
    return url;
  }

  if (url.startsWith('/') || !url.startsWith('http')) {
    return `${cdnBaseUrl}${url.startsWith('/') ? url : '/' + url}`;
  }

  if (url.includes(cdnBaseUrl)) {
    return url;
  }

  const urlPath = url.replace(/^https?:\/\/[^\/]+/, '');
  return `${cdnBaseUrl}${urlPath}`;
}

export function buildMediaCdnUrl(mediaUrl: string, cdnBaseUrl: string): string {
  return buildCdnUrl(mediaUrl, cdnBaseUrl);
}

